(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift_card_recipient_form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-card-recipient-form')) {
    customElements.define(
      'gift-card-recipient-form',
      class GiftCardRecipientForm extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.toggle = this.querySelector('[data-recipient-toggle]');
          this.fields = this.querySelector('[data-recipient-fields]');
          this.email = this.querySelector('[data-recipient-email]');
          this.message = this.querySelector('[data-recipient-message]');
          this.sendOn = this.querySelector('[data-recipient-send-on]');
          this.offset = this.querySelector('[data-recipient-offset]');
          this.control = this.querySelector('[data-recipient-control]');
          this.characterCount = this.querySelector('[data-recipient-character-count]');
          this.liveRegion = this.querySelector('[data-recipient-live]');
          if (!this.toggle || !this.fields || !this.email) return;
          this.toggle.addEventListener('change', () => this.updateState());
          if (this.message) {
            this.message.addEventListener('input', () => this.updateCharacterCount());
          }
          this.setDateConstraints();
          this.updateState();
        }

        updateState() {
          const active = this.toggle.checked;
          this.fields.hidden = !active;
          this.toggle.setAttribute('aria-expanded', String(active));
          this.querySelectorAll('[data-recipient-field]').forEach((field) => {
            field.disabled = !active;
            if (active) {
              field.name = field.dataset.name;
            } else {
              field.removeAttribute('name');
            }
          });
          this.email.required = active;
          if (active) {
            if (this.control) this.control.value = 'true';
            if (this.offset) this.offset.value = new Date().getTimezoneOffset().toString();
            this.setDateConstraints();
            this.updateCharacterCount();
          } else {
            this.email.required = false;
            this.updateCharacterCount();
          }
          if (this.liveRegion) {
            this.liveRegion.textContent = active ? this.dataset.expandedText : this.dataset.collapsedText;
          }
        }

        updateCharacterCount() {
          if (!this.message || !this.characterCount) return;
          const template = this.characterCount.dataset.template || '[current]/[max]';
          this.characterCount.textContent = template
            .replace('[current]', this.message.value.length.toString())
            .replace('[max]', this.message.maxLength.toString());
        }

        setDateConstraints() {
          if (!this.sendOn) return;
          const today = new Date();
          const maxDate = new Date();
          maxDate.setDate(today.getDate() + 90);
          this.sendOn.min = this.formatDate(today);
          this.sendOn.max = this.formatDate(maxDate);
        }

        formatDate(date) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
